import { MLSID, isNonEmptyString } from '@aloft/toolkit-shared';

import {
  CompPropertyDataState,
  PropertyDataSliceExtraReducer,
  SubjectPropertyDataState,
} from '../../../types.ts';
import { submitEditPropertyDetailsForm } from '../../actions/submitEditPropertyDetailsForm.ts';
import { submitEditSubjectPropertyDetailsForm } from '../../actions/submitEditSubjectPropertyDetailsForm.ts';
import { submitObjectiveCharacteristicsForm } from '../../actions/submitObjectiveCharacteristicsForm.ts';
import { propertyDataAdapter } from '../../propertyDataAdapter.ts';
import { getChangedEntityFromEditableData } from '../utils/getChangedEntityFromEditableData.ts';
import { objectiveCharacteristicsFormToEditableData } from '../utils/objectiveCharacteristicsFormToEditableData.ts';

export const submitEditPropertyFormExtraReducers: PropertyDataSliceExtraReducer = (builder) => {
  builder.addCase(submitEditPropertyDetailsForm, (state, action) => {
    const { id, address, mls, mlsListingID } = action.payload;

    const current = state.entities[id];
    if (!current) return;

    const isSubject = id === 'subject';
    const propertyData = isSubject
      ? (current as SubjectPropertyDataState).subjectData
      : (current as CompPropertyDataState).compData;

    const { propertyIdentification, transaction } = propertyData.editableData;

    propertyDataAdapter.updateOne(
      state,
      getChangedEntityFromEditableData(current, {
        propertyIdentification: {
          ...propertyIdentification,
          address,
        },
        transaction: {
          ...transaction,
          mls: isNonEmptyString(mls) ? (mls as MLSID) : undefined,
          mlsListingID,
        },
      }),
    );
  });
  builder.addCase(submitEditSubjectPropertyDetailsForm, (state, action) => {
    const subject = state.entities.subject as SubjectPropertyDataState | undefined;
    if (!subject) return;

    const currentPropertyIdentification = subject.subjectData.editableData.propertyIdentification;

    propertyDataAdapter.updateOne(
      state,
      getChangedEntityFromEditableData(subject, {
        // @ts-expect-error - `hoaFeeAmount` will be converted to `AloftPriceJSON` by `serializeAloftObjectMiddleware`
        propertyIdentification: {
          ...currentPropertyIdentification,
          ...action.payload,
        },
      }),
    );
  });

  builder.addCase(submitObjectiveCharacteristicsForm, (state, action) => {
    const { id } = action.payload;

    const current = state.entities[id];
    if (!current) return;

    const isSubject = id === 'subject';
    const propertyData = isSubject
      ? (current as SubjectPropertyDataState).subjectData
      : (current as CompPropertyDataState).compData;

    const { improvements, site, transaction } = propertyData.editableData;

    const {
      improvements: newImprovements,
      site: newSite,
      transaction: newTransaction,
    } = objectiveCharacteristicsFormToEditableData(action.payload);

    propertyDataAdapter.updateOne(
      state,
      getChangedEntityFromEditableData(current, {
        improvements: {
          ...improvements,
          ...newImprovements,
        },
        site: {
          ...site,
          ...newSite,
        },
        transaction: {
          ...transaction,
          ...newTransaction,
        },
      }),
    );
  });
};
